"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreeNodeColor;
(function (TreeNodeColor) {
    TreeNodeColor[TreeNodeColor["BLACK"] = 0] = "BLACK";
    TreeNodeColor[TreeNodeColor["RED"] = 1] = "RED";
})(TreeNodeColor || (TreeNodeColor = {}));
exports.default = TreeNodeColor;
//# sourceMappingURL=tree-node-color.js.map